import { useTranslation } from 'react-i18next';
import React from 'react';

const GlobalActionsCloseText = () => {
  const { t } = useTranslation('global_shared');

  return <>{t('global_shared:actions.close')} </>;
};

export default GlobalActionsCloseText;
